import { useMemo } from 'react'
import { Props } from '../typings'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import { formatUSPhoneNumber } from '../utils'

export function useData(props: Props) {
  const {
    searchItem: { companyName, name, entityType, address, phone },
    searchText,
  } = props

  const addressDisplayName = useMemo(() => {
    if (address && formatUSPhoneNumber(phone).trim()) {
      return address + '\u00a0\u00a0\u00a0\u2022\u00a0\u00a0\u00a0'
    } else return address || ''
  }, [address, phone])

  const canadaZipAwareSearchText = useMemo(
    () =>
      searchText &&
      /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ]([-]*| *)[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/.test(
        searchText,
      )
        ? searchText.replaceAll('-', '').replaceAll(' ', '').slice(0, 3) +
          ' ' +
          searchText.replaceAll('-', '').replaceAll(' ', '').slice(3)
        : searchText,
    [searchText],
  )

  const entityTypeDisplay = useMemo(() => {
    switch (entityType.toLowerCase()) {
      case 'lead':
        return 'Lead'
      case 'opportunity':
        return 'Opportunity'
      case 'draftlead':
        return 'Pending Lead'
    }
  }, [entityType])

  const nameAndCompanyDisplay = useMemo(() => {
    const items = [name, companyName].filter((x) => x && x.trim().length > 0)
    if (items.length > 1) {
      return items.join(' / ')
    } else {
      return items[0] || ''
    }
  }, [companyName, name])

  const [open, toggleOpen] = useToggleBoolean(false)

  return {
    addressDisplayName,
    entityTypeDisplay,
    open,
    toggleOpen,
    nameAndCompanyDisplay,
    canadaZipAwareSearchText,
  }
}

export type UseData = ReturnType<typeof useData>
